import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  FormContainer,
  NextButton,
  Prompt,
  QuestionContainer,
  QuestionPageContainer,
  TextInput,
} from "~/OnboardingApp/components";
import { usePartner } from "~/OnboardingApp/hooks";
import { useOnboarding } from "~/OnboardingApp/hooks/useOnboarding";
import { useSubmitOnboardingQuestion } from "~/OnboardingApp/hooks/useSubmitOnboardingQuestion";
import { requiredText } from "~/utils/validations";

type Values = {
  biggestChallenge: string;
};

const validationSchema = Yup.object({
  biggestChallenge: requiredText,
});

const optionalValidationSchema = Yup.object({
  biggestChallenge: Yup.string(),
});

export const MostChallengingPage: FC = () => {
  const { t } = useTranslation();
  const { biggestChallenge } = useOnboarding();
  const { onSubmit } = useSubmitOnboardingQuestion();
  const { isPartner } = usePartner();

  const initialValues: Values = {
    biggestChallenge: biggestChallenge || "",
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema: isPartner ? optionalValidationSchema : validationSchema,
    validateOnMount: true,
  });

  return (
    <QuestionPageContainer>
      <FormContainer formik={formik}>
        <QuestionContainer>
          <Prompt question={t("onboarding.mostChallenging.question")} />

          <TextInput
            id="biggestChallenge"
            placeholder={t("onboarding.mostChallenging.placeholder")}
          />
        </QuestionContainer>

        <NextButton />
      </FormContainer>
    </QuestionPageContainer>
  );
};
